import { render, staticRenderFns } from "./ReactColumnActions.vue?vue&type=template&id=2c903583&scoped=true&"
import script from "./ReactColumnActions.vue?vue&type=script&lang=js&"
export * from "./ReactColumnActions.vue?vue&type=script&lang=js&"
import style0 from "./ReactColumnActions.vue?vue&type=style&index=0&id=2c903583&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c903583",
  null
  
)

export default component.exports